// extracted by mini-css-extract-plugin
export default {"cls1":"CreateSocialItemModal-cls1__20","cls2":"CreateSocialItemModal-cls2_z5l CreateSocialItemModal-cls1__20"};